<template>
  <div class="ComInvite padding-1">
    <div class="ComInvite_font">{{ $t(title) }}</div>
    <div class="ComInvite_warp mt-1">
      <div class="mb-1">
        {{ $t(value) }}
      </div>
      <div class="ComInvite_width">
        <ComButton class="" @click="clickPopup">{{ $t(btnLabel) }}</ComButton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComInvite",
  props: {
    btnLabel: {
      type: String,
      default: "111",
    },
    list: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: "邀请好友购买就能赢取提成，邀请的好友越多获得的收益越多！",
    },
    title: {
      type: String,
      default: "邀请好友 收取提成",
    },
    btnLabel: {
      type: String,
      default: "立即邀请",
    },
  },
  data() {
    return {};
  },
  methods: {
    clickPopup() {
      this.$emit("clickInvite");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>